import CarouselSkeleton from './CarouselSkeleton';

export default CarouselSkeleton;
